
import React, { useState, useEffect } from "react";
import {useNavigationParse} from "@arctheme-hooks/useNavigationParse";
import { isTouchDevice } from "frontend/js/helpers";

declare global {
    interface Window {
        megamenuParents: any;
        Alpine: any
    }
}

export const HeaderMenu = ({ link_list, settings }) => {
    const [activeLink, setActiveLink] = useState(null);
    const [hoveredLink, setHoveredLink] = useState(null);
    const [parents, setParents] = useState(window.megamenuParents || []);

    const menuLinks = link_list[0].links;
    const {
        show_caret,
        header_font_type = 'h2',
        dim_other_menus = false,
        rotate_menu_icons = true,
        megamenu_trigger = 'onhover'
    } = settings.section;


    useEffect(() => {
        window.addEventListener("megamenu-closed", handleMenuClose);

        if (hoveredLink !== null) {
            const event = new CustomEvent('megamenu-hover', {
                detail: { message: hoveredLink }
            });

            window.dispatchEvent(event);
        }

        return () => {
            setHoveredLink(null);
            window.removeEventListener("megamenu-closed", handleMenuClose);
        };
    }, [hoveredLink]);

    useEffect(() => {
        const handler = (e) => setParents(e.detail);

        window.addEventListener('megamenuParentsUpdate', handler);
        return () => window.removeEventListener('megamenuParentsUpdated', handler);
    }, []);

    const handleMenuClose = () => {
        setHoveredLink(null);
    };

    const handleMouseEnter = (dataId) => {
        setHoveredLink(dataId);

        if (!dim_other_menus) return;
        document.body.classList.add('dim-header-menu');
    }

    const handleMouseLeave = () => {
        if (!dim_other_menus) return;
        document.body.classList.remove('dim-header-menu');
    }

    const handleIconClick = (detail) => {
        if (!detail || (megamenu_trigger !== 'onclick' && !isTouchDevice())) return;
        
        if (activeLink === detail) {
            setActiveLink(null);
            handleMouseLeave();
            const event = new CustomEvent('megamenu-close');
            window.dispatchEvent(event);

        } else { 
            setActiveLink(detail);
            handleMouseEnter(detail);

            const event = new CustomEvent('menuIconClick', { detail });
            window.dispatchEvent(event);
        }
    }

    return (
        <div className="header-links">
            <div className="block">
                <ul className={`header-menu header-menu-${megamenu_trigger} inline-flex gap-8 m-0 p-0`}>
                    {menuLinks.map((link, id) => {
                        const text = useNavigationParse(link.title);
                        const titleLowerCase = text.text.toLowerCase();
                        const dataId = `header-${titleLowerCase.replace(' ', '-')}`;
                        const activeClass = activeLink === dataId ? 'active' : '';
                        const hoverClass = hoveredLink === dataId ? 'hovered' : '';
                        const rotateClass = rotate_menu_icons ? 'rotate-icon' : '';

                        return (
                            <li
                                key={id}
                                className={`${header_font_type} ${rotateClass} ${activeClass}`}
                                data-id={dataId}
                                onMouseEnter={() => megamenu_trigger === 'onhover' && handleMouseEnter(dataId)}
                                onMouseLeave={() => megamenu_trigger === 'onhover' && handleMouseLeave()}
                            >
                                <span 
                                    className={`inline-flex justify-center items-center gap-[8px] menu-link`}
                                    onClick={(e) => {
                                        if (megamenu_trigger === 'onclick' && parents?.includes(text.text)) {
                                            e.preventDefault();
                                            handleIconClick(dataId);
                                        }
                                    }}
                                >
                                    <a
                                        href={link.url}
                                        className={`${hoverClass}`}
                                        onClick={(e) => {
                                            if (megamenu_trigger === 'onclick' && parents?.includes(text.text)) {
                                                e.preventDefault();
                                            }
                                        }}
                                    >
                                        <div className={`menu-link__link`}>
                                            {text.text}
                                        </div>
                                    </a>

                                    {parents?.includes(text.text) && (
                                        <i
                                            className={`menu-link__icon icon-chevron-down no-underline`}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleIconClick(dataId);
                                            }}
                                        ></i>
                                    )}
                                </span>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
};
